import { render } from "./NewInvoice.vue?vue&type=template&id=1b422d7c&ts=true"
import script from "./NewInvoice.vue?vue&type=script&lang=ts"
export * from "./NewInvoice.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__